var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{directives:[{name:"svg",rawName:"v-svg"}],class:_vm.iconClass,attrs:{"role":"presentation","symbol":_vm.iconName,"size":_vm.iconSize,"fill":_vm.iconFill,"preserveAspectRatio":"XMidYMid meet"}})}
var staticRenderFns = []

export { render, staticRenderFns }